import React from "react";
import AllData from "../../components/hotel/table/component";

const Component = () => {
  return <AllData tableHeading="All Hotels" />;
};

export default Component;
